export default __webpack_public_path__ + "assets/progresso.6e111fbd.jpg";